import { selectFormType } from "./qualityFormSlices/qualityFormCommons";
import { selectPermission } from "features/auth/currentUserSlice";
import { RootState } from "app/store";
import FormType from "enums/FormType";
import QualityFormPermission from "enums/qualityFormPermission";

export const selectHasAddPermissions = (state: RootState) => {
    const formType = selectFormType(state);
    return (
        (formType === FormType.EVALUATION &&
            selectPermission(
                state,
                QualityFormPermission.QUALITY_EVAL_FORM_ADD
            )) ||
        (formType === FormType.SURVEY &&
            selectPermission(
                state,
                QualityFormPermission.QUALITY_SURV_FORM_ADD
            )) ||
        (formType === FormType.ASSESSMENT &&
            selectPermission(state, QualityFormPermission.LEARNING_MODULE_ADD))
    );
};

export const selectHasAIScoringEditPermission = (state: RootState) => {
    const formType = selectFormType(state);
    return (
        formType === FormType.EVALUATION &&
        selectPermission(
            state,
            QualityFormPermission.QUALITY_EVAL_FORM_AI_SCORING_EDIT
        )
    );
};
